import { bookAudioKey, DUB_LANGS } from "./bookDub";

/**
 * 👻 **없는 책의 읽어주기 소리** — 매니페스트에는 남았는데 그 책이 목록에 없는 것.
 *
 * ## 🔴 왜 (2026-09-11 · 《폴짝》을 전수 조사하다 찾았다)
 * `book_mt2ejmvu` 라는 책은 이미 없는데 소리 20개(10쪽 × 한·영)가 게시본에 남아 있었다.
 * 아이 화면에는 안 나오지만, 「소리 파일 몇 개 있나」를 셀 때마다 **114개 중 20개가 부풀려진** 채였다.
 * 관리자에서 지울 길도 없었다 — 그 책의 화면이 없으니까.
 *
 * ## 판정
 * `book.audio.<책>.<쪽>.<말>` 꼴인데 `<책>` 이 **아이가 보는 책 목록에 없으면** 유령이다.
 * 🔴 아주 오래된 **책 이름 없는 키**(`book.audio.<쪽>.<말>`)는 뷰어가 아직 폴백으로 읽는다 —
 *    유령이 아니다. 조각 수로 가른다(책 이름이 있으면 다섯 조각).
 * 🔴 지우는 게 아니라 **숨긴다**(`hidden: true`) — 게시본에서 키를 빼면 정적 기본이 되살아난다.
 */
export function ghostAudioKeys(assets: Record<string, { url?: string; hidden?: boolean }>, bookIds: readonly string[]): string[] {
  const books = new Set(bookIds);
  const out: string[] = [];
  for (const k of Object.keys(assets)) {
    if (!k.startsWith("book.audio.")) continue;
    const parts = k.split(".");
    if (parts.length !== 5) continue; // 책 이름 없는 옛 키(4조각) — 뷰어가 아직 읽는다
    const [, , bookId, pageId, lang] = parts;
    if (!bookId || !pageId || !DUB_LANGS.includes(lang as (typeof DUB_LANGS)[number])) continue;
    if (bookAudioKey(bookId, pageId, lang as (typeof DUB_LANGS)[number]) !== k) continue;
    if (assets[k]?.hidden) continue; // 이미 숨긴 것
    if (!books.has(bookId)) out.push(k);
  }
  return out;
}

/** 유령을 책 이름별로 세어 사람 말로 — 「book_mt2ejmvu 20개」. */
export function ghostAudioSay(keys: readonly string[]): string {
  const by = new Map<string, number>();
  for (const k of keys) {
    const id = k.split(".")[2] ?? "?";
    by.set(id, (by.get(id) ?? 0) + 1);
  }
  return [...by.entries()].map(([id, n]) => `${id} ${n}개`).join(" · ");
}
